import React, { useState, useEffect, useCallback } from "react";
import styles from "./RangeInputPair.module.scss";

const RangeInput = ({
  value,
  onChange,
  placeholder,
  unit,
  format,
  parse,
  convertLabel,
}) => {
  const formatValue = format || ((v) => String(v));
  const parseValue = parse || ((v) => {
    const n = parseFloat(v.replace(/[^\d.]/g, ""));
    return isNaN(n) ? null : n;
  });

  const [text, setText] = useState(
    value != null ? formatValue(value) : ""
  );

  useEffect(() => {
    setText(value != null ? formatValue(value) : "");
  }, [value, format]);

  const handleChange = (e) => {
    setText(e.target.value.replace(/[^\d.]/g, ""));
  };

  const commit = () => {
    if (text === "") {
      onChange(null);
      return;
    }
    const parsed = parseValue(text);
    onChange(parsed);
    if (parsed != null) {
      setText(formatValue(parsed));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commit();
    }
  };

  return (
    <div className={styles.inputCol}>
      <div className={styles.inputWrapper}>
        <input
          className={styles.input}
          value={text}
          onChange={handleChange}
          onBlur={commit}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          inputMode="decimal"
          autoComplete="off"
        />
        {unit && <span className={styles.unit}>{unit}</span>}
      </div>
      <span className={styles.convertLabel}>
        {convertLabel && value != null ? convertLabel(value) : ""}
      </span>
    </div>
  );
};

const RangeInputPair = ({
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  unit,
  minPlaceholder = "최소",
  maxPlaceholder = "최대",
  format,
  parse,
  convertLabel,
  separator = "~",
  className,
}) => {
  return (
    <div className={`${styles.pair} ${className || ""}`}>
      <RangeInput
        value={minValue}
        onChange={onMinChange}
        placeholder={minPlaceholder}
        unit={unit}
        format={format}
        parse={parse}
        convertLabel={convertLabel}
      />
      <span className={styles.separator}>{separator}</span>
      <RangeInput
        value={maxValue}
        onChange={onMaxChange}
        placeholder={maxPlaceholder}
        unit={unit}
        format={format}
        parse={parse}
        convertLabel={convertLabel}
      />
    </div>
  );
};

export default RangeInputPair;
